<template>
  <config-base :config-plan-tile-status="configPlanTileStatus" :show-plan-details="showPlanDetails" :plan-details-label="planDetailsLabel" class="opc-zwb" @view-details="handleViewDetails">
    <template #topAlert>
      <zm-alert v-if="!!topAlert" type="info" :closable="false" class="opc-base-alert">
        <div class="opc-base-alert__main">
          <i class="zm-icon-info" />
          <p class="opc-base-alert__main_message" v-html="topAlert" />
        </div>
      </zm-alert>
    </template>
    <div slot="config" class="opc-zwb__config">
      <input-number-with-popover
        class="opc-zwb__quantity-selector"
        v-model="selectedNumber"
        size="large"
        controls-position="both"
        :min="minHosts"
        :max="maxHosts"
        @change="changeLicense"
        :decrease-tips="decreaseTips"
        :unit="$t('billing.planform.unit.license')"
        :label="trackingPlanName + ' Select the number of users'" />
      <bought-license :type="planTypes.ZOOM_WHITEBOARD" v-if="showBoughtLicensesDesc" />
      <alert v-if="mx_downSellLicenseErrorMessage" class="additional-template__alert" type="info">
        <span v-html="mx_downSellLicenseErrorMessage" />
      </alert>
      <license-tip ref="licenseTip" v-else :type="'zwb'" :number="selectedNumber" :additional-spans="additionalSpans">
      </license-tip>
      <config-cycle
        v-model="billingCycle"
        :billing-cycle-list="billingCycleList"
        :showMonthlyPriceFromCycle="true"
        @switchCycleAction="switchCycleAction"
        :show-cycle-alert="showCycleAlert"
      />
      <preview-payment class="opc-zwb__preview-payment" />
    </div>
    <template #footer v-if="canRmv">
      <zm-button data-testid="checkout-button-255" type="link" ghost @click="removePlanByKey('ZOOM_WHITEBOARD')" :aria-label="'remove ' + trackingPlanName + ' plan'">
        {{ $t('billing.common.remove') }}
      </zm-button>
    </template>
  </config-base>
</template>

<script type="text/jsx">
import _ from 'lodash';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import plansMixin from '@/plans/mx/plan';
import ConfigBase from '@/components/config-base';
import commonMixin from '@/plans/ZOOM_WHITEBOARD/mixin';
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover';
import {
  trackingPlanTypes,
  planTypes,
  isPlanIncludeUnlimitedWhiteboard,
  BASE_PLAN_SUB_TYPES,
  BILLING_CYCLE,
  isZoomOneBusinessPlan,
  isZoomOneBusinessPlusPlan,
  isZoomWorkplaceEduSchoolAndCampusPlan,
  isZoomWorkplaceEduSchoolAndCampusPlusPlan,
  isZoomMeetingEduPlan
} from '@/common/constants';
import ConfigCycle from '@/components/service/config-billing-cycle/index';
import LicenseTip from '@/plans/ZOOM_MEETING/license-tip.vue';
import Alert from '@/components/zoom-ui-plus/alert/alert.vue';
import AddonMixin from '@/plans/mx/addon';
import mxPlanDetails from '../dialog/mx-plan-details';
import PreviewPayment from '@/views/checkout/payment/preview-payment';
import BoughtLicense from '@/views/config/shopping-cart/prorated/bought-license.vue';
import { WHITEBOARD_PLUS_PLAN_MAPS } from '../pre';
import { getEditUrl } from '@/views/succezz/utils'

const ConfigBaseComp = {
  name: 'zwb-base',
  extends: ConfigBase,
  key: planTypes[planTypes.ZOOM_WHITEBOARD],
  mixins: [commonMixin],
  props: {
    showPlanDetails: Boolean,
    planDetailsLabel: String,
  },
  data() {
    return {
      showLearnMore: false
    };
  },
};

export default {
  name: 'WhiteboardBase',
  mixins: [plansMixin, commonMixin, AddonMixin, mxPlanDetails],
  components: {
    BoughtLicense,
    PreviewPayment,
    ConfigCycle,
    InputNumberWithPopover,
    ConfigBase: ConfigBaseComp,
    LicenseTip,
    Alert
  },
  data() {
    return {
      selectedNumber: 1,
      billingCycle: '',
      trackingPlanName: trackingPlanTypes.ZOOM_WHITEBOARD,
      showCycleAlert: true,
      planTypes,
    };
  },
  computed: {
    ...mapGetters([
      'getSelectedPlansMap',
      'getSelectedPlans',
      'boughtPlans',
      'planMapFlat',
      'getUserCurrentSubscriptions',
      'getCurrentBasePlanInfo',
      'getTypeGroupSelectedPlans',
    ]),
    showBoughtLicensesDesc() {
      return true;
    },
    planList() {
      return this.planMapFlat.filter((p) => {
        const isCurrentPlanType = p.type === this.planType;
        const isCurrentCategory = p.category === this.selectedPlan.category
        return isCurrentPlanType && isCurrentCategory
      });
    },
    selectedPlan() {
      return this.getTypeGroupSelectedPlans[this.planType]?.[0];
    },
    minHosts() {
      return 1;
    },
    maxHosts() {
      return 99;
    },
    decreaseTips() {
      return '';
    },
    zwbAsBasePlan() {
      return this.getCurrentBasePlanInfo.planType === this.planType;
    },
    currentPlanCycleDepFirstPlan() {
      const dependCyclePlanList = _.get(this.planList, [0, 'billingCycleDependBasePlanTypeList'], []);

      return _.chain(this.getUserCurrentSubscriptions)
        .filter((p) => _.includes(dependCyclePlanList, p.type))
        .orderBy((p) => p.cycleValue, 'desc')
        .get(0)
        .value();
    },
    depCurrentAllAddonPlanList() {
      return _.filter(this.getUserCurrentSubscriptions,
        (p) => _.includes(p.dependBasePlanTypeList, this.planType));
    },
    disabledForBulkLicense() {
      return () => false;
    },
    disabledForBulkLicenseTips() {
      return this.$t('billing.error.buld_acount_license');
    },
    canRmv() {
      return false;
    },
    showPlanDetails() {
      return true;
    },
    planDetailsLabel() {
      return '';
    },
    additionalSpans() {
      return {};
    },
    topAlert() {
      const alertMap = {
        alreadyIncludeWhiteboardInBasePlan: () => {
          const planList = this.getSelectedPlans.concat(this.boughtPlans)
          const planIncludeUnlimitedWhiteboard = planList.find(p => isPlanIncludeUnlimitedWhiteboard(p))

          const currentIsWhiteboardBasic = !this.isWhiteboardPlus
          const doNotShowCases = {
            whiteboardBasicIsMultipleRate: this.whiteboardBasicIsMultipleRate
          }
          if (planIncludeUnlimitedWhiteboard && currentIsWhiteboardBasic && Object.values(doNotShowCases).every(doNotShow => doNotShow === false)) {
            const i18nKeyMap = {
              'billing.zoom_whiteboard_plus.already_include_in_biz': isZoomOneBusinessPlan,
              'billing.zoom_whiteboard_plus.already_include_in_biz_plus': isZoomOneBusinessPlusPlan,
              'billing.zoom_whiteboard_plus.already_include_in_edu': isZoomWorkplaceEduSchoolAndCampusPlan,
              'billing.zoom_whiteboard_plus.already_include_in_edu_plus': isZoomWorkplaceEduSchoolAndCampusPlusPlan,
              'billing.zoom_whiteboard_plus.already_include_in_meeting_edu': isZoomMeetingEduPlan
            }
            const defaultI18n = 'billing.zoom_whiteboard_plus.already_include_in_workplace'
            const i18nKey = Object.keys(i18nKeyMap).find(key => i18nKeyMap[key](planIncludeUnlimitedWhiteboard)) || defaultI18n

            return this.$t(i18nKey)
          }
          return null
        }
      };

      // find the first active alert to display
      return Object.keys(alertMap).reduce((activeAlert, key) => {
        if (activeAlert) {
          return activeAlert
        } else {
          const alertGenerator = alertMap[key]
          return alertGenerator && alertGenerator()
        }
      }, null)
    },
    boughtWhiteboardPlusPlan() {
      return this.boughtPlans?.find(p => p?.category === BASE_PLAN_SUB_TYPES.WHITEBOARD_PLUS)
    },
    boughtWhiteboardBasicPlan() {
      return this.boughtPlans?.find(p => p?.category === BASE_PLAN_SUB_TYPES.WHITEBOARD_BASIC)
    },
    whiteboardBasicIsMultipleRate() {
      return this.boughtWhiteboardBasicPlan?.ratePlans?.length > 1 ?? false
    }
  },
  methods: {
    ...mapMutations(['updateSelectPlan']),
    ...mapActions(['switchBillingCycleAction', 'switchSelectPlanAction']),
    changeLicense(newLicense,oldLicense) {
      this.selectedNumber = newLicense;
      this.updateSelectPlan({
        plan_code: this.selectedPlan?.plan_code,
        cartInfo: { selected_number: newLicense },
      });
      this.mx_validDownSellLicense(newLicense)

      this.$tracking.buyInteraction(
          `number of licenses`,
          `${this.trackingPlanName} - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${newLicense}`,
      );

      if(newLicense === this.maxHosts){
        this.$tracking.buyInteraction(
          'banner - product level',
          `${this.trackingPlanName} - the maximum amount is ${this.maxHosts} licenses - impression`,
        );
      }
    },
    async switchCycleAction(oldPlan, newPlan) {
      // when the current license less than max, get current license, otherwise get maxHosts
      const quantity = this.selectedNumber <= this.maxHosts ? this.selectedNumber : this.maxHosts;
      const newPlanInfo = { ...newPlan, cartInfo: { selected_number: quantity } };

      await this.switchBillingCycleAction([
        oldPlan?.plan_code,
        newPlanInfo,
      ]);

      // event tracking
      const billingCycle = this.selectedPlan?.billing_cycle;
      billingCycle && this.$tracking.addOnBuyInteraction(
        `${this.trackingPlanName} billing cycle`,
        this.$t(`billing.billing_cycle.${billingCycle}`)?.toLowerCase(),
      );
    },
    async handleViewDetails() {
      await this.showPlanDetailDialog();
    },
    bindLinkClickEventInAlert(isShow) {
      const bindMap = [
        {
          selector: '.opc-zwb .opc-base-alert__main_message a.opc-wb-2-plus',
          handler: () => {
            const goToWhiteboardPlusEditPage = () => {
              // go to whiteboard plus edit page
              const basePlanInfo = this.getCurrentBasePlanInfo?.plans[0]
              const editUrl = getEditUrl(basePlanInfo, this.boughtWhiteboardPlusPlan)
              location.href = editUrl
            }
            const switchWhiteboardToWhiteboardPlus = () => {
              // Due to script in Optimizely: [ZTSPZ-218][ABC-ECOMM] 2024.01 - Zoom One Pricing Page - Annual Savings Promo Expansion Full-Scaled
              // Optimizely will poll and listen to DOM changes and modify the price DOM (especially the annual price)
              // If you don't trigger a click event in the code, the code in Optimizely will not be triggered until the user clicks or performs other operations on the interface
              // During this long period of time, the price displayed on the whiteboard is still the price of the whiteboard, not the price of plus
              // So one way is to manually click a text to trigger optimizely
              function triggerClickToUpdatePrice() {
                const selectorList = ['.opc-zm-base-card__main--desc__content', '.opc-cycle__title']
                selectorList.some(s => {
                  const el = document.querySelector(`.opc-zwb ${s}`)
                  if (el && typeof el.click === 'function') {
                    el.click()
                    return true
                  } else {
                    return false
                  }
                })
              }
              // switch whiteboard to whiteboard plus
              const newPlanInfo = {
                selectedNumber: this.selectedNumber,
                billing_cycle: this.selectedPlan.billing_cycle
              }

              this.switchSelectPlanAction(
                [
                  this.selectedPlan?.plan_code,
                  {
                    plan_code: newPlanInfo.billing_cycle === BILLING_CYCLE.MONTHLY ? WHITEBOARD_PLUS_PLAN_MAPS.MONTHLY : WHITEBOARD_PLUS_PLAN_MAPS.ANNUAL,
                    cartInfo: { selected_number: newPlanInfo.selectedNumber },
                  }
                ]
              );
              this.category = BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS;
              this.$nextTick(triggerClickToUpdatePrice);
            }

            if (this.boughtWhiteboardPlusPlan) {
              goToWhiteboardPlusEditPage()
            } else {
              switchWhiteboardToWhiteboardPlus()
            }
          }
        }
      ];

      if (isShow) {
        this.$nextTick(() => {
          bindMap.forEach(({ selector, handler }) => {
            if (selector && document.querySelector(selector)) {
              document.querySelector(selector)?.removeEventListener('click', handler)
              document.querySelector(selector)?.addEventListener('click', handler)
            }
          })
        })
      } else {
        bindMap.forEach(({ selector, handler }) => {
          if (selector && document.querySelector(selector)) {
            document.querySelector(selector)?.removeEventListener('click', handler)
          }
        })
      }
    }
  },
  created() {
    const selectedPlan = this.selectedPlan;

    if (selectedPlan) {
      this.billingCycle = selectedPlan.billing_cycle;
      this.selectedNumber = selectedPlan.cartInfo?.selected_number;

      // refresh page
      this.$nextTick(() => {
        this.mx_validDownSellLicense(this.selectedNumber);
      });
    }
  },
  mounted(){
    this.$refs?.licenseTip?.$el?.addEventListener('click', (e) => {
      if (e?.target?.tagName === 'A') {
        this.$tracking.buyInteraction(
          'banner - product level',
          `${this.trackingPlanName} - the maximum amount is ${this.maxHosts} licenses - contact sales`,
        );
      }
    });
  },
  watch: {
    topAlert: {
      immediate: true,
      handler (newVal) {
        this.bindLinkClickEventInAlert(!!newVal)
      }
    }
  }
};
</script>

<style lang="scss">
.opc-zwb {
  &__quantity-selector{
    margin-bottom: 10px;
  }

  &__preview-payment {
    margin-top: 24px;
  }

  .opc-base-alert {
    &__main {
      display: flex;
      align-items: center;
      $main-color: #666487;
      i {
        font-size: 16px;
        color: $main-color;
        margin-right: 16px;
      }
      &__message {
        color: $main-color;
      }
    }
  }
}
</style>
